import { RouterService } from './../router.service';
import { SettingService } from './../setting.service';
import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { AppComponent } from '../app.component';
import { ActivatedRoute } from '@angular/router';
import { SendMessageService } from '../send-message.service';
import { DonateChangeService } from '../donate-change.service';
import { DonateData } from '../donate-data';
import { CheckIdService } from '../check-id.service';
import { MatTable } from '@angular/material/table';
import { ControlData } from '../controll-screen/control-data';
import { SettingData } from '../setting-data';
import { CookieService } from 'ngx-cookie-service';
import { ScrollDispatcher} from '@angular/cdk/scrolling';
import * as $ from "jquery";
// declare var jquery: any;
// declare let $: any;
@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  @ViewChild('table') table: MatTable<Element>;
  @HostListener('window:scroll', ['$event'])
  donateList: Array<DonateData>;
  checkIDState = 0;
  id: string;
  displayedColumns: string[] = ['name', 'donate', 'time', 'msg'];
  settingData: SettingData;
  owner: boolean;
  constructor(
    private appComponent: AppComponent,
    private activateRouter: ActivatedRoute,
    public routerService: RouterService,
    private donateChange: DonateChangeService,
    private checkIDService: CheckIdService,
    private sendMessage: SendMessageService,
    private settingService: SettingService,
    private cookieService: CookieService,
    private scrollDispatcher: ScrollDispatcher,
  ) {
    this.settingService.settingDataChange.subscribe((settingData) => {
      this.settingData = settingData;
    });
    this.donateChange.donateDataListChange.subscribe((value) => {
      this.donateList = value;
      if (this.table) {
        console.log('render');
        this.table.renderRows();
      }
    });
    this.checkIDService.checkStateChange.subscribe((value) => {
      if (value === 1) {
        this.checkIDState = 1;
      } else {
        alert('此ID不存在');
        routerService.GoToHomePage();
      }
    });
  }

  ngOnInit(): void {
    this.id = this.activateRouter.snapshot.paramMap.get('id');
    this.appComponent.client.subscribe('check_id/' + this.id + '/res');
    this.appComponent.client.subscribe('control/' + this.id + '/res');
    this.appComponent.client.subscribe('donate/' + this.id + '/res');
    this.appComponent.client.subscribe('account/' + this.id + '/res');
    this.getList();
    this.sendMessage.sendMessage(this.appComponent.client, JSON.stringify({id: this.id, action: 'login'}), 'account/' + this.id + '/send');
    this.sendMessage.sendMessage(
      this.appComponent.client,
      JSON.stringify({ id: this.id }),
      'check_id/send'
    );
    if (this.checkID()) {
      this.owner = true;
    }
    else {
      this.owner = false;
    }
  }
  onScroll(event) {
    if ($('#content').scrollTop()) {
      $('nav').addClass('black');
    }
    else {
      $('nav').removeClass('black');
    }
  }
  getList(): void {
    const contorlData: ControlData = new ControlData(this.id, 'get');
    const message = JSON.stringify(contorlData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'control/' + this.id + '/send'
    );
  }
  checkID(): boolean {
    if (!this.cookieService.check('id')) {
      return false;
    }
    if (this.cookieService.get('id') === this.id) {
      return true;
    }
    return false;
  }
}
